module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-1500.a4411460.svg";